import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

import ChangeCalculatorForm from '../components/ChangeCalculatorForm'
import { getTotal } from '../selectors/cart'
import { addPaymentToOrderInProgress, closeNoOpTender } from '../actions/order'

import PeripheralBridge from '../utils/peripheralBridge'
import { addTempPaymentToOrder } from '../VNOrders/ActionCreators'
import { VNORDERS_FEATURE_ENABLED } from '../VNOrders/Enums'
import { getOrderInProgress } from '../selectors/order'

const mapStateToProps = (state, ownProps) => {
  const paymentId = ownProps?.match?.params?.paymentId
  const tenderAmountInCents = ownProps?.history?.location?.state?.tenderAmountInCents ?? 0
  const total = paymentId ? tenderAmountInCents : getTotal(state)
  const order = getOrderInProgress(state)

  return {
    total,
    paymentId,
    order,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const paymentId = ownProps?.match?.params?.paymentId
  const tenderAmountInCents = ownProps?.history?.location?.state?.tenderAmountInCents ?? 0
  const goBack = get(ownProps, 'history.goBack', () => {})

  return {
    onBack: () => {
      goBack()
    },
    onComplete: (amountPaid, noPaymentRequired, cashRoundingInCents, isLastPayment = true) => {
      const bridge = PeripheralBridge.getBridge()
      if (bridge && !noPaymentRequired) bridge.call('openDrawer')

      // temporary
      if (VNORDERS_FEATURE_ENABLED) {
        dispatch(
          addTempPaymentToOrder({
            amount_in_cents: amountPaid,
            payment_type: 'cash',
            short_description: 'Cash',
          }),
        )
        return
      }

      if (paymentId) {
        /**
         * Adjusted values for cash rounding to ensure that we only apply cash rounding to the final payment when there are multiple payments.
         * If this is not the final payment, we set cash rounding to 0 and add the cash rounding amount to the tender amount so that
         * the remaining balance reflects the cash rounding adjustment.
         */
        const adjustedCashRoundingInCents = isLastPayment ? cashRoundingInCents : 0
        const adjustedTenderAmountInCents = isLastPayment ? tenderAmountInCents : tenderAmountInCents + cashRoundingInCents

        dispatch(
          addPaymentToOrderInProgress({
            tenderAmountInCents: adjustedTenderAmountInCents,
            paymentId,
            paymentType: 'cash',
            shortDescription: 'Cash',
            cashRoundingInCents: adjustedCashRoundingInCents,
          }),
        )
      } else {
        dispatch(closeNoOpTender({ redirectOnSync: true, cashRoundingInCents }))
      }
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeCalculatorForm))
